import { useTranslation } from "react-i18next";
import PopupContainer from "../../Popup_Container.jsx";
import { FileText, Globe, Archive, Info } from "lucide-react";

function PatientNewCaseFilesGuidePop({ text }) {
  const { t } = useTranslation();
  return (
    <PopupContainer open={true}>
      <div className="p-md-3">
        <h2 className="fs-4">{t("newCase.fileUploadInstructionsTitle")}</h2>
        <p>{t("newCase.fileUploadInstructionsText")}</p>
        <div className="d-flex flex-column gap-3 mt-3">
          {/* Upload Clear Copy */}
          <div className="d-flex align-items-start gap-3 p-3 rounded bg-body-tertiary">
            <FileText
              className="text-primary flex-shrink-0 mt-1"
              style={{ width: "20px", height: "20px" }}
            />
            <div>
              <h4 className="fw-medium fs-6 mb-1">
                {t("newCase.uploadClearCopyTitle")}
              </h4>
              <p
                className="text-muted text-wrap mb-0"
                style={{ maxWidth: "500px" }}
              >
                {t("newCase.uploadClearCopyText")}
              </p>
            </div>
          </div>

          {/* English or French Only */}
          <div className="d-flex align-items-start gap-3 p-3 rounded bg-body-tertiary">
            <Globe
              className="text-primary flex-shrink-0 mt-1"
              style={{ width: "20px", height: "20px" }}
            />
            <div>
              <h4 className="fw-medium fs-6 mb-1">
                {t("newCase.languageRestrictionTitle")}
              </h4>
              <p
                className="text-muted text-wrap mb-0"
                style={{ maxWidth: "500px" }}
              >
                {t("newCase.languageRestrictionText")}
              </p>
            </div>
          </div>

          {/* Compress Large Files */}
          <div className="d-flex align-items-start gap-3 p-3 rounded bg-body-tertiary">
            <Archive
              className="text-primary flex-shrink-0 mt-1"
              style={{ width: "20px", height: "20px" }}
            />
            <div>
              <h4 className="fw-medium fs-6 mb-1">
                {t("newCase.compressFilesTitle")}
              </h4>
              <p
                className="text-muted text-wrap mb-0"
                style={{ maxWidth: "500px" }}
              >
                {t("newCase.compressFilesText")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </PopupContainer>
  );
}
export default PatientNewCaseFilesGuidePop;
